import React from 'react';
import Copy from "../../../../picture/copy.svg";
import CheckBlue from "../../../../picture/check-blue.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";
import './style/copyToClipboard.css';

export default function CopyToClipboardComponent({data}) {

    const [copied, setCopied] = React.useState(false);
    const timeout = React.useRef(null);

    const handleCopy = React.useCallback(() => {
		clearTimeout(timeout.current);
		setCopied(true);
		timeout.current = setTimeout(() => setCopied(false), 2000);
	}, [timeout]);

    return (
        <div className='wz-copy-to-clipboard'>
            <input className='wz-copy-to-clipboard-input'value={data.resale_option.url} disabled/>
            <CopyToClipboard text={data.resale_option.url} onCopy={handleCopy}>
                <div className='wz-copy-to-clipboard-img-container'>
                    <img className='wz-copy-to--clipboard-img' alt='' src={copied ? CheckBlue : Copy}/>
                </div>
            </CopyToClipboard>
        </div>
    )
};